import { StyledSizeButton } from "./Sizes.styled";

type SizeButtonProps = {
  refine: (value: string) => void;
  value: string;
  label: string;
  active?: boolean;
};

function SizeButton({
  refine,
  value,
  label,
  active,
}: SizeButtonProps): JSX.Element {
  const handleClick = () => {
    refine(value);
  };

  return (
    <StyledSizeButton onClick={handleClick} className={active ? "active" : ""}>
      {label}
    </StyledSizeButton>
  );
}

export { SizeButton };
